import request from '@/utils/request'
// 查询modeler列表点位数据列表（地图1.0）
export function queyrList(query) {
    return request({
        url: '/zwmap/conditionQuery',
        method: 'post',
        data: query
    })
}

// /zwmap/lifeCycle  获取生命周期  不传参  post
export function lifeCycle(query) {
    return request({
        url: '/zwmap/lifeCycle',
        method: 'post',
        data: query
    })
}
// /zwmap/matterQuery  根据服务类型和生命周期查询事项  post         
//生命周期id    lifeCycleId;
//服务类型id    serviceTypeId; 个人"1" 法人"2"
export function matterQuery(query) {
    return request({
        url: '/zwmap/matterQuery',
        method: 'post',
        data: query
    })
}

// /zwmap/lifeCycleMatter
export function lifeCycleMatter(query) {
    return request({
        url: '/zwmap/lifeCycleMatter',
        method: 'post',
        data: query
    })
}

// /zwmap/matterInfo  事项详情  post  参数 matterId  事项id
export function matterInfo(query) { 
    return request({
        url: '/zwmap/matterInfo',
        method: 'post',
        data: query
    })
}
// /zwmap/matterMapQuery  地图查询事项  post  参数 name  事项名字或者地址
export function matterMapQuery(query) { 
    return request({
        url: '/zwmap/matterMapQuery',
        method: 'post',
        data: query
    })
}
//  /zwmap/deptList   post  不传参  部门列表
export function GetdeptList(query) { 
    return request({
        url: '/zwmap/deptList',
        method: 'post',
        data: query
    })
}

// 办事材料上传
export function uploadMaterialFile(query) { 
    return request({
        url: '/zwmap/uploadMaterialFile',
        method: 'post',
        data: query
    })
}

// 登录
export function doLogin(query) { 
    return request({
        url: '/zwmap/wechat/toLogin',
        method: 'post',
        data: query
    })
}
// 
export function wxLogin(query) { 
    return request({
        url: '/zwmap/wechat/login',
        method: 'post',
        data: query
    })
}
// 用户基本信息绑定
export function saveUserInfo(query) { 
    return request({
        url: '/zwmap/binder',
        method: 'post',
        data: query
    })
}
// 特色乡村--获取乡镇列表--无参
export function getVillages(query) { 
    return request({
        url: '/zwmap/getVillages',
        method: 'post',
        data: query
    })
}
// 特色乡村--获取服务器当前时间，根据当前月判断季节--无参
export function getServerDate(query) { 
    return request({
        url: '/zwmap/getDate',
        method: 'post',
        data: query
    })
}

// 无需鉴权
export function unauthorized(query) {
    return request({
        url: '/zwmap/governmentMap/unauthorized',
        method: 'post',
        data: query
    })
}